<template>
    <div class="bg-white p-4 h-[68px] rounded-lg shadow-md">
      <div class="flex flex-wrap">
        <div class="flex flex-1">
          <fwb-heading tag="h2" class="text-style-xl">
            Propiedad
          </fwb-heading>
        </div>
        <div class="flex flex-1 justify-end items-end">
          <fwb-breadcrumb>
            <fwb-breadcrumb-item href="/Propiedades">
              Lista de propiedades
            </fwb-breadcrumb-item>
  
            <fwb-breadcrumb-item> Agregar nuevo inmueble </fwb-breadcrumb-item>
          </fwb-breadcrumb>
        </div>
      </div>
  
      <!-- inicio de contenido -->
      <div
        class="w-full bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700 mt-5 sm:mt-10"      
      >
        <fwb-tabs
          v-model="activeTab"
          class="p-5"
        >
          <fwb-tab
            name="first"
            title="Datos generales"
          >
            <p class="text-sm font-normal leading-6 text-black "> 
              Por favor, completa todos los campos obligatorios marcados con un asterisco (*). 
              La información precisa y detallada ayudará a que tu inmueble destaque en el mercado. 
            </p>
            <!-- Mostrar el mensaje adicional solo si hay una URL de 'partners' -->
            <p v-if="propertyData.partners && propertyData.partners.length > 0 && propertyData.partners[0].url && propertyData.partners[0].status === 'active'" class="mt-3 text-sm font-normal leading-6 text-black">
              Puedes consultar tu propiedad en <a :href="propertyData.partners[0].url" target="_blank" class="text-blue-500">propiedades.com</a> aquí.
            </p>
  
            <FormComponent 
              :property-id="id" 
            />        
          </fwb-tab>
  
          <fwb-tab 
            name="gallery" 
            title="Galería" 
            :disabled="!active_tab"
          >
            <FormGalleryComponent 
              :property-id="id" 
            />
          </fwb-tab>

          <fwb-tab 
            name="video" 
            title="Video" 
            :disabled="!active_tab"
          >
            <FormVideoComponent
              :property-id="id" 
            />
          </fwb-tab>
  
          <fwb-tab 
            name="characters" 
            title="Características" 
            :disabled="!active_tab"
          >
            <FormCharacteristicsComponent 
              :property-id="id" 
              section="characteristics"
            /> 
          </fwb-tab>
  
          <fwb-tab 
            name="amenities" 
            title="Amenidades" 
            :disabled="!active_tab"
          >
            <FormCharacteristicsComponent 
              :property-id="id" 
              section="amenities"
            /> 
          </fwb-tab>
  
          <fwb-tab 
            name="service" 
            title="Servicios" 
            :disabled="!active_tab"
          >
            <FormCharacteristicsComponent 
              :property-id="id" 
              section="service"
            /> 
          </fwb-tab>

          <fwb-tab 
            name="friendly" 
            title="Friendly" 
            :disabled="!active_tab"
          >
            <FormCharacteristicsComponent 
              :property-id="id" 
              section="friendly"
            /> 
          </fwb-tab>
  
          <fwb-tab 
            name="requeriments" 
            title="Requisitos" 
            :disabled="!active_tab"
          >
            <FormCharacteristicsComponent 
              :property-id="id" 
              section="requeriments"
            /> 
          </fwb-tab>
        </fwb-tabs>
      </div>
      <head>
          <link href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600&display=swap" rel="stylesheet">
      </head>
    </div>
  </template>
  <script setup>
  import FormCharacteristicsComponent from "@/components/properties/FormCharacteristicsComponent.vue";
  import FormComponent from "@/components/properties/FormComponent.vue";
  import FormGalleryComponent from "@/components/properties/FormGalleryComponent.vue";
  import FormVideoComponent from "@/components/properties/FormVideoComponent.vue";
  import axios from "axios";
  import {
    FwbBreadcrumb,
    FwbBreadcrumbItem,
    FwbHeading,
    FwbTab,
    FwbTabs,
  } from "flowbite-vue";
  import { ref, onMounted, watch, computed} from "vue";
  import { useRoute } from "vue-router";
  import { useStore } from "vuex";
  let store = useStore();
  let session = computed(() => store.getters.getUserSession);

  
  // Acceder al parámetro 'id' de la URL directamente
  const route = useRoute();
  let id = route.params.id;
  let active_tab = ref(false);
  
  const activeTab = ref("first");
  let propertyData = ref({}); 

  onMounted(async () => {
    console.log(id);
    if (id != undefined) {
      active_tab.value = true;
      await getProperty();
    }
  });

  async function getProperty() {
    let url_cnn = `${process.env.VUE_APP_API_BASE_URL}/broker/property/${id}`;

    var options = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${session.value.token_api}`,
      },
    };

    try {
      const response = await axios.get(url_cnn, options);
      const resp = response.data.resp;

      propertyData.value = resp; // Guardar los datos de la propiedad en propertyData

    } catch (error) {
      console.log("[ERROR]", error.response);
    }
  }

  watch(
    () => route.params.id,
    (newId) => {
      console.log('[-----]', newId);
      id = newId;
      getProperty(); // Vuelve a cargar los datos cuando cambie el ID
    }
  );
  </script>